
import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import {
  Link,
  useParams,
} from "react-router-dom"

import {
  AppCtx,
} from '$src/App'
import {
  PeriodsCtx,
} from '$src/components/periods'
import SchedulesCtx from './SchedulesCtx'
import {
  apiRouter,
  appRouter,
  C,
  logg,
} from '$shared'

/**
 * SchedulesList
 * aka Data Views
**/
const SchedulesList = (props) => {
  // logg(props, 'SchedulesList')

  const params = useParams()
  // logg(params, 'params in SchedulesList')

  const {
    actionName,
    currentUser, setCurrentUser,
  } = useContext(AppCtx)

  const {
    scheduleShowRef,
    schedulesOpen, setSchedulesOpen,
    schedulesList,
  } = useContext(SchedulesCtx)
  // logg(useContext(SchedulesCtx), 'useContext(SchedulesCtx) in SchedulesList')
  if (!schedulesList[0]?.value) { schedulesList.shift() }

  const handleClick = (ev, props) => {
    logg(props, 'handleClick in SchedulesList')
    // if fintegration and user doesn't have access to it
    if ('FINTEGRATION' === props.value && // _TODO: remove? looks like it never gets called
         currentUser.roles.indexOf(C.roles.INTERNAL === -1) &&
         currentUser.roles.indexOf(C.roles.FINTEGRATION === -1) ) {
           // @TODO: show unauthorized modal
           // @TODO: test-driven
           return
    }

    scheduleShowRef.current && scheduleShowRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  return <div className={`SchedulesList`} >
    <h5 className='text-center'>Data Views</h5>
    <ul>
      { schedulesList.map(({label, value}) => {
        const url = 'docs#show' === actionName
          ? appRouter.docsShowPath(value)
          : appRouter.bankSchedulePath({ bank_rssd: params.rssd, schedule_id: value })
        return <Link key={value} to={url} onClick={(ev) => handleClick(ev, { value, }) } >
          <li key={value}

            className={params.schedule_id === value ? 'active' : null} >
            { label }</li>
        </Link> }
      )}
    </ul>
  </div>
}
export default SchedulesList

